import { SoundSection, SupportSection, VideoSection } from "./conference-settings-sections";

export const ConferenceSettingsContent = ({
  activeSection,
  userChoices,
  saveAudioInputDeviceId,
  saveAudioInputEnabled,
  saveVideoInputDeviceId,
  saveVideoInputEnabled,
  microphoneVolume,
  speakerVolume,
  setMicrophoneVolume,
  setSpeakerVolume,
  soundSectionProps,
  supportSectionProps,
}) => {
  if (activeSection === "video") {
    return (
      <VideoSection
        userChoices={userChoices}
        saveVideoInputDeviceId={saveVideoInputDeviceId}
        saveVideoInputEnabled={saveVideoInputEnabled}
      />
    );
  }

  if (activeSection === "support") {
    return <SupportSection {...supportSectionProps} />;
  }

  return (
    <SoundSection
      userChoices={userChoices}
      saveAudioInputDeviceId={saveAudioInputDeviceId}
      saveAudioInputEnabled={saveAudioInputEnabled}
      microphoneVolume={microphoneVolume}
      speakerVolume={speakerVolume}
      setMicrophoneVolume={setMicrophoneVolume}
      setSpeakerVolume={setSpeakerVolume}
      {...soundSectionProps}
    />
  );
};
